import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

interface NavigationLessonsProps {
  numOfLessons?: number;
}

interface LessonLink {
  path: string;
  lessonNumber: number;
  label: string;
}

export const NavigationLessons: React.FC<NavigationLessonsProps> = ({
  numOfLessons = 8,
}) => {
  const location = useLocation();

  const lessonLinks: LessonLink[] = Array.from(
    { length: numOfLessons },
    (_, i) => {
      const lessonNumber = i + 1;
      return {
        path: `${location.pathname}/lessons/${lessonNumber}`,
        lessonNumber,
        label: `Урок №${lessonNumber}`,
      };
    }
  );

  const activeKey =
    lessonLinks.find((lesson) => location.pathname === lesson.path)?.path ||
    '';

  return (
    <Nav 
      variant="pills" 
      activeKey={activeKey}
      role="navigation"
      aria-label="Навігація по урокам"
      style={{ marginBottom: '1.5rem' }}
    >
      {lessonLinks.map((lesson) => (
        <Nav.Item key={lesson.path}>
          <Nav.Link 
            as={Link} 
            to={lesson.path} 
            eventKey={lesson.path}
            aria-current={activeKey === lesson.path ? 'page' : undefined}
            aria-label={`Перейти до ${lesson.label}`}
          >
            {lesson.label}
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};
